export const getUpcomingEvents = state => state?.events?.upcomingEvents;
export const getEventDetails = state => state?.events?.eventsInfo;
export const getMyEvents = state => state?.events?.myEvents;
export const getStudentEventSignUpStatus = state =>
  state?.events?.studentEventSignUpStatus;
